export default __webpack_public_path__ + "32f9f988b2552eb94381ce1166cf4112.svg";